import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseItem from "../card/CourseItem";
import { useDispatch, useSelector } from "react-redux";
import { getCompletedCourses } from "../../../../api/afterLogin/courses";
import { setConfigData } from "../../../../reducers/configSlice";
import NoItemsInfo from "../NoItemsInfo";
import { parseISO } from "date-fns";

function MyCourseCarousel({ setHasError }) {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const [enrolledCompletedCourses, setEnrolledCourses] = useState([]);
  const configData = useSelector((state) => state.config);
  const paths = useSelector((state) => state.user.paths);
  const fetchCompletedCourses = async () => {
    try {
    const enrolledCompletedCourses = await getCompletedCourses(
      configData.access_token,{},
      { enroll_status: ["completed"] }
    );
    setEnrolledCourses(enrolledCompletedCourses);
    } catch (error) {
      setHasError(true);
      console.error(error);
    } 
  };

  useEffect(() => {
    fetchCompletedCourses();
  }, []);

  const courseData = enrolledCompletedCourses.map((value) => {
    const isExpired = value?.cs_course_validity_status === '0' ? false : value?.cs_end_date && parseISO(value?.cs_end_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? false : true;
    return {
      className: "",
      courseImage: value.cb_image ? paths.course_path + value.cb_image : "",
      courseType: value?.item_type,
      courseTitle: value?.cb_title,
      courseLectureCount: `${value?.lecture_count ?? 0} Lecture${
        value?.lecture_count > 1 ? "s" : ""
      }`,
      courseTypeLearning: value?.category,
      courseDetailLink: `/student-dashboard/courses/detail/${value?.cb_slug}` ?? '',
      isExpired: isExpired ? 'expired' : ''
    };
  });

  dispatch(setConfigData({coursecount: courseData.length }));

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1368,
        settings: {
          slidesToShow: 2,
          rows: 2,
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <>
    {courseData.length === 0 ? (
      <NoItemsInfo 
        className="myk__stu-empty-com_courseapprent" 
        title="No Completed Courses Yet!"
        description="Once you complete your courses, it will appear here." 
      />
    ) : (
      <Slider {...settings} ref={ref}>
        {courseData.map((course, index) => (
          <CourseItem key={index} {...course} />
        ))}
      </Slider>
    )}
    </>
  );
}

export default MyCourseCarousel;
